// BulkDeleteSlicer.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from '../../../api/axiosInstance';
export const bulkDeleteFunc = createAsyncThunk(
    "bulkDeleteProduct",
    async ({ data }, thunkAPI) => {
        try {
            const response = await api.post('dashboard/products/bulk-delete', data);
            return response.data;
        }
        catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }

    });
const bulkDeleteSlicer = createSlice({
    name: "bulkDeleteProduct",
    initialState: {
        loading: false,
        data: [],
        error: null,
        apiErrors: {},
        successMessage: "",
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(bulkDeleteFunc.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.apiErrors = {};
        })
            .addCase(bulkDeleteFunc.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
                state.successMessage = action.payload?.message || "";
            })
            .addCase(bulkDeleteFunc.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
                state.apiErrors = action.payload?.errors || {};
            });
    }
});
export default bulkDeleteSlicer.reducer;